const notification = {
    notificationDropdown: document.getElementById('notificationDropdown'),
    notificationHeader: document.getElementById('notificationHeader'),
    notificationContent: document.getElementById('notificationContent'),
    notificationsLoaded: false,
    markAllAsRead: function () {
        axios.post('/admin/notifications/read-all', null, {
            headers: {
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            console.debug(response);
            if (response.data.success) {
                location.reload(); // Refresh to update the UI
            }
        }).catch((error) => {
            console.error('Error marking notifications as read:', error);
        });
    },
    hasNotification: function () {
        axios.get('/admin/notifications/has-notification', null, {
            headers: {
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            console.debug(response);
            if (response.data.success) {
                // location.reload(); // Refresh to update the UI
            }
        }).catch((error) => {
            console.error('Error marking notifications as read:', error);
        });
    },
    getNotifications: function () {
        axios.get('/admin/notifications', null, {
            headers: {
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            console.debug(response);
            const data = response.data.data || [];
            if (data) {
                this.notificationsLoaded = true;
                this.renderNotifications(data);
                // location.reload(); // Refresh to update the UI
            }
        }).catch((error) => {
            console.error('Error fetching notifications:', error);
            this.renderError();
        });
    },
    renderNotifications: function(notifications) {
        // Update header
        // this.notificationHeader.innerHTML = `${notifications.length} Notification${notifications.length !== 1 ? 's' : ''}`;

        // Update badge
        // this.updateNotificationBadge(unreadCount);

        // Clear content
        this.notificationContent.innerHTML = '';

        if (notifications.length > 0) {
            notifications.forEach((notification) => {
                const notificationElement = this.createNotificationElement(notification);
                this.notificationContent.appendChild(notificationElement);
            });


        } else {
            // No notifications
            const emptyState = document.createElement('div');
            emptyState.className = 'dropdown-item text-center text-muted';
            emptyState.innerHTML = `
                <div class="my-3">
                    <svg class="icon icon-xl">
                        <use xlink:href="{{ asset('vendors/@coreui/icons/svg/free.svg#cil-bell') }}"></use>
                    </svg>
                    <div class="mt-2">No notifications</div>
                </div>
            `;
            this.notificationContent.appendChild(emptyState);
        }
    },
    createNotificationElement: function(notification) {

        const url = notification.data.url || '#';
        const title = notification.data.title || 'Notification';
        const message = notification.data.message || '';
        const time = notification.created_at || '';
        // const type = notification.data.type || 'info';
        // const icon = notification.icon || 'cil-bell';
        const read = !!notification.read_at;

        const link = document.createElement('a');
        link.href = url;
        link.className = `dropdown-item nav-link`;

        link.innerHTML = `
            <div class="media">
            <div class="media-body">
                <h6 class="dropdown-item-title">
                    <span class="float-right text-sm">
                        ${!read ? '<span class="bg-danger rounded-circle d-inline-block ml-2" style="width: 8px; height: 8px;"></span>' : ''}
                        <span class="font-weight-semibold">${title}</span>
                    </span>
                </h6>
                <div class="text-sm my-1">${message}</div>
                <div class="text-sm text-muted my-1">
                    <i class="nav-icon cil-clock mr-1"></i>
                    ${time}
                </div>
            </div>
            </div>
        `;

        return link;
    },
    renderError: function () {
        this.notificationHeader.innerHTML = 'Error loading notifications';
        this.notificationContent.innerHTML = `
            <div class="dropdown-item text-center text-danger">
                <div class="my-3">
                    <svg class="icon icon-xl">
                        <use xlink:href="{{ asset('vendors/@coreui/icons/svg/free.svg#cil-warning') }}"></use>
                    </svg>
                    <div class="mt-2">Failed to load notifications</div>
                    <button class="btn btn-sm btn-outline-primary mt-2" onclick="location.reload()">Retry</button>
                </div>
            </div>
        `;
    },
    init: function () {
        const self = this
        this.notificationDropdown.addEventListener('click', function () {
            if (!self.notificationsLoaded) {
                self.getNotifications();
            }
        });
    }
}

export default notification;
